export const JOURNEY_USER_COUNT_CUTOFF_DATE = "2022-07-19";
